import React, { Component } from 'react';
import Modal from 'react-modal';

class NoteModal extends Component {
  state = {
    isOpen: false,
  };

  openModal = () => {
    this.setState({ isOpen: true });
  };

  closeModal = () => {
    this.setState({ isOpen: false });
  };

  render() {
    const { isOpen } = this.state;
    document.body.style.overflow = isOpen ? 'hidden' : '';
    const { id: weekId, note = '' } = this.props.week;
    const icon = note.length > 0 ? '🔖' : '➕';
    const iconStyles =
      note.length > 0 ? { fontSize: 28 } : { fontSize: 11, opacity: 0.5 };

    return (
      <div style={styles.container}>
        <a style={styles.handle} onClick={this.openModal}>
          <span
            style={{ ...styles.handleIcon, ...iconStyles }}
            role="img"
            aria-label="note"
          >
            {icon}
          </span>
        </a>
        <Modal
          ariaHideApp={false}
          isOpen={isOpen}
          shouldCloseOnOverlayClick
          onRequestClose={this.closeModal}
          style={styles.modal}
        >
          <div style={styles.modalContainer}>
            <div style={styles.closeContainer}>
              <button style={styles.closeButton} onClick={this.closeModal}>
                &times;
              </button>
            </div>
            <div style={styles.noteContainer}>
              <textarea
                autoFocus
                placeholder="Enter notes..."
                style={styles.textArea}
                onChange={e => {
                  this.props.updateWeekNote(weekId, e.target.value);
                }}
                value={note}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

const styles = {
  container: {
    zIndex: 10,
    position: 'absolute',
    top: 0,
    right: 0,
  },
  handle: {
    cursor: 'pointer',
  },
  handleIcon: {
    textShadow: '0px 1px 3px #777',
  },
  modal: {
    overlay: {
      zIndex: 15,
      background: 'rgba(0,0,0,.33)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    content: {
      position: 'unset',
      width: '15%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
  },
  modalContainer: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
  },
  closeContainer: {
    alignItems: 'flex-end',
    display: 'flex',
    justifyContent: 'flex-end',
    marginBottom: 10,
  },
  closeButton: {
    cursor: 'pointer',
    border: 'none',
    backgroundColor: '#10ca97',
    color: 'white',
    height: 30,
    width: 30,
    fontSize: 22,
    borderRadius: '50%',
  },
  noteContainer: {
    display: 'flex',
    flex: 1,
    margin: '1rem',
  },
  textArea: {
    resize: 'vertical',
    display: 'flex',
    flex: 1,
    width: '100%',
    height: '100%',
    fontSize: '3rem',
    border: '1px solid #ccc',
    minHeight: 400,
    outline: 0,
    padding: 10,
  },
};

export default NoteModal;



// WEBPACK FOOTER //
// ./src/components/NoteModal/NoteModal.js